module.exports = __webpack_public_path__ + "img/GOOGL.52d6acf2.png";